<template>
  <div class="dashboard-overview">
    <!-- KYC 验证提示横幅 -->
    <div v-if="showKycVerifyBanner === 1 || showKycVerifyBanner === 4" class="kyc-verify-banner">
      <div class="kyc-verify-banner-content">
        <div class="kyc-verify-banner-title"><i class="el-icon-warning" style="color: #FFA900"> </i> {{ $t('kyc.dashboard_kyc_title') }}</div>
        <div class="kyc-verify-banner-subtitle">{{ $t('kyc.dashboard_kyc_subtitle') }}</div>
      </div>
      <el-button type="primary" class="kyc-verify-banner-btn" @click="goToKyc">{{ $t('kyc.dashboard_kyc_btn_text') }}</el-button>
    </div>
    <MyBalanceAndExchangeRate v-if="$store.getters.isAllCountry" />
    <BalancePanel v-else />
    <TotalTransactionDataPannel
      @changeShowType="changeShowType"
      @currency-change="handleCurrencyChange"
    />
    <div class="data-container">
      <div class="data-container-title">
        {{ $t('dashboard.transaction_trends') }}
        <el-tooltip v-if="$store.getters.isPii" placement="bottom">
          <div slot="content">
            <span>{{ $t('tips.current_time_zone') }}</span>
          </div>
          <span><svg-icon icon-class="icon-font-warning" style="width: 22px;color: #3855F1;cursor: pointer;" /></span>
        </el-tooltip>
      </div>
      <div class="data-container-search">
        <span>{{ $t('components.date') }}:</span>
        <el-select v-model="activeColor" class="search-frame mb-10" size="small" clearable @change="onClickchangeTimes">
          <el-option
            v-for="(item,index) in dateArr"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-select v-model="showType" class="search-frame  mb-10" size="small" clearable>
          <el-option
            v-for="(item,index) in showTypeTransaction === 'second' ? transactionPayin : transaction"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-search" @click="getCharData">{{ $t('components.search') }}</el-button>
      </div>
    </div>
    <div class="bar-container">
      <bar-chart v-loading="loading" :char-data="charData" />
    </div>

  </div>
</template>

<script>
import {
  fetchDisbursementData,
  fetchMultiMchDisbursementData,
  fetchMultiMchPaymentData,
  fetchPaymentData
} from '@/api/dashboard/dashboard'
import { appointDate } from '@/utils/index'
import BalancePanel from './BalancePanel'
import BarChart from './BarChart'
import TotalTransactionDataPannel from './TotalTransactionDataPannel'
import MyBalanceAndExchangeRate from './MyBalanceAndExchangeRate'

export default {
  name: 'Dashboard-Overview',
  components: {
    BalancePanel,
    BarChart,
    TotalTransactionDataPannel,
    MyBalanceAndExchangeRate
  },
  data() {
    return {
      search: {
        times: [appointDate(0), appointDate()]
      },
      charData: {
        payAmountY: [],
        timesX: [],
        disAmountY: []
      },
      activeColor: 'day',
      currency: undefined,
      showType: 'number',
      showTypeTransaction: '',
      loading: false,
      dashboardMounted: false,
      pickerOptions: {
        disabledDate: this.disabledDate
      }
    }
  },
  computed: {
    // 是否显示 KYC 验证提示横幅（未认证或审核驳回时显示）
    showKycVerifyBanner() {
      const merchantInfo = this.$store.getters.userInfo && this.$store.getters.userInfo.merchant_info
      return merchantInfo && merchantInfo.kyc_status ? merchantInfo.kyc_status : null
    },
    dateArr() {
      return [
        { label: this.$t('dashboard.today'), value: 'day' },
        { label: this.$t('dashboard.week'), value: 'week' },
        { label: this.$t('dashboard.month'), value: 'month' }
      ]
    },
    transaction() {
      return [
        { label: this.$t('dashboard.transaction_count'), value: 'number' },
        { label: this.$t('dashboard.transaction_amount'), value: 'amount' }
      ]
    },
    transactionPayin() {
      return [
        { label: this.$t('dashboard.transaction_count'), value: 'number' },
        { label: this.$t('dashboard.transaction_amount'), value: 'amount' }
      ]
    }
  },
  watch: {
    '$store.getters.language'() {
      this.getCharData()
    }
  },
  mounted() {
    this.dashboardMounted = true
    const { token } = this.$store.getters
    if (token) {
      this.getCharData()
    }
  },
  methods: {
    // 跳转到 KYC 认证页面
    goToKyc() {
      this.$router.push('/kyc')
    },
    disabledDate(time) {
      return time.getTime() > Date.now()
    },
    // 获取支付和代付数据
    getCharData() {
      let params = { range: (this.activeColor || 'day').toUpperCase() }
      const isAllCountry = this.$store.getters.isAllCountry
      if (isAllCountry) {
        if (!this.currency) {
          return
        }
        const [start_date, end_date] = this.search.times
        params = { start_date, end_date, currency: this.currency }
      }
      if (this.loading) {
        return
      }
      this.loading = true
      const fetchPayment = isAllCountry ? fetchMultiMchPaymentData : fetchPaymentData
      const fetchDisbursement = isAllCountry ? fetchMultiMchDisbursementData : fetchDisbursementData
      Promise.all([fetchPayment(params), fetchDisbursement(params)]).then((res) => {
        const [payData = {}, disData] = res
        const { code: payCode, data: charPayY } = payData
        const { code: disCode, data: charDisY } = disData
        // 获取支付金额y轴数据
        const totalAmouts = []
        const totalNumbers = []
        const toDivide100 = this.$options.filters['toDivide100']
        const payAmountY = charPayY.map(item => {
          const itemAmout = toDivide100(item.total_amount)
          totalAmouts.push(itemAmout)
          return itemAmout
        })
        // 获取支付笔数y轴数据
        const payNumberY = charPayY.map(item => {
          const itemNumber = item.daily_count
          totalNumbers.push(itemNumber)
          return itemNumber
        })
        // 获取代付金额y轴数据
        const disAmountY = charDisY.map((item, index) => {
          const itemAmout = toDivide100(item.total_amount)
          totalAmouts[index] = totalAmouts[index] + itemAmout
          return itemAmout
        })
        // 获取代付笔数y轴数据
        const disNumberY = charDisY.map((item, index) => {
          const itemNumber = item.daily_count
          totalNumbers[index] = totalNumbers[index] + itemNumber
          return itemNumber
        })
        // 获取x轴数据
        const timesX = charPayY.map(item => {
          if (item.create_date_str && item.create_date_str.includes('-')) {
            return item.create_date_str.split('-').slice(1).join('/')
          } else {
            return item.create_date_str
          }
        })

        if (this.showType === 'number') {
          this.charData = {
            payY: payNumberY,
            disY: disNumberY,
            // allY: totalNumbers,
            timesX,
            config: {
              yAxisName: this.$t('dashboard.number'),
              seriesName: [this.$t('dashboard.payin_number'), this.$t('dashboard.payout_number'), 'all number']
            }
          }
        }
        if (this.showType === 'amount') {
          this.charData = {
            payY: payAmountY,
            disY: disAmountY,
            // allY: totalAmouts,
            timesX,

            config: {
              yAxisName: this.$t('dashboard.amount'),
              seriesName: [this.$t('dashboard.payin_amount'), this.$t('dashboard.payout_amount'), 'all amount']
            }
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onClickchangeTimes(dateStr) {
      let day = new Date().getDay()
      day = day === 0 ? 7 : day // 0是周日，周日设置为7
      const curDate = new Date().getDate()

      // 将月份下移到下一个月份，同时将日期设置为0；由于Date里的日期是1~31，所以Date对象自动跳转到上一个月的最后一天；getDate（）获取天数即可。
      const zeroDayDate = new Date()
      // 将当前月份加1，下移到下一个月
      zeroDayDate.setMonth(zeroDayDate.getMonth() + 1)
      // 将当前的日期置为0，
      zeroDayDate.setDate(0)
      // 再获取天数即取上个月的最后一天的天数
      const monthTotalDays = zeroDayDate.getDate()

      const dateRange = {
        'day': [appointDate(0), appointDate(0)],
        'week': [appointDate(-7), appointDate(-1)],
        'month': [appointDate(-30), appointDate(-1)]
      }
      this.search.times = dateRange[dateStr]
      // this.getCharData()
    },
    onClickSearchBtn() {
      this.getCharData()
    },
    changeShowType(value) {
      this.showTypeTransaction = value
    },
    handleCurrencyChange(currency) {
      if (!this.$store.getters.isAllCountry) {
        return
      }
      this.currency = currency
      if (this.dashboardMounted) {
        this.getCharData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .dashboard-overview {
    margin: 40px 57px 50px 32px;
  }
  // KYC 验证提示横幅样式
  .kyc-verify-banner {
    display: flex;
    align-items: center;
    padding: 20px 24px;
    margin-bottom: 24px;
    background-color: rgba(255, 169, 0, 0.02);
    border: 1px solid rgba(255, 169, 0, 0.50);
    border-radius: 12px;
  }
  .kyc-verify-banner-content {

    flex: 1;
  }
  .kyc-verify-banner-title {
    margin-bottom: 4px;
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    line-height: 22px;
  }
  .kyc-verify-banner-subtitle {
    font-size: 13px;
    color: #666666;
    line-height: 20px;
  }
  .kyc-verify-banner-btn {
    margin-left: 24px;
    padding: 10px 24px;
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    background-color: #3451B2;
    border-color: #3451B2;
    border-radius: 6px;
    &:hover {
      background-color: #2A4299;
      border-color: #2A4299;
    }
  }
  .data-container{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-top: 32px;
    .data-container-title{
      font-weight: 700;  font-family: 'Inter-Bold';
      font-size: 24px;
      line-height: 1.2;
      color: #1D3A71;
      margin-bottom: 32px;
    }
    .data-container-search{
      margin-bottom: 32px;
      .search-frame{
        margin-right: 24px;
      }
      span{
        margin-right: 16px;
        font-weight: 400;
        font-size: 12px;
        line-height: 15px;
        color: #4B5567;
      }
    }
  }
  .bar-container{
    border: 1.5px solid #D3D7DF;
    border-radius: 12px;
    padding-bottom: 15px;
  }
  // @media screen and (max-width: 1024px) {
  //   .data-container-title{
  //     margin-bottom: 24px;
  //   }
  // }
</style>
